function getSphereById(tourData, sphereId) {
    // For large tours this may start to take some time. If v2 spec doesn't switch tour.spheres to a map by id,
    // then we should add some caching here.
    let spheres = tourData ? tourData.spheres : [];
    return spheres.find((sphere) => sphere.sphereId === sphereId);
}
function findGroupById(tourData, groupId) {
    let groups = tourData !== null ? tourData.groups : [];
    return groups.find((group) => group.groupId === groupId);
}

function findStartSphereIdForAGroup(tourData, groupId) {
    let selectedGroup = findGroupById(tourData, groupId);
    let selectedGroupStartSphereId = selectedGroup.startSphereId;
    // If there isnt any startSphereId mentioned for the
    // group use the very first sphere associated with the group.
    if (!selectedGroupStartSphereId) {
        selectedGroupStartSphereId = selectedGroup.sphereIds[0];
    }
    return selectedGroupStartSphereId;
}

function findGroupBySphereId(tourData, sphereId) {
    let groups = tourData !== null ? tourData.groups : [];
    return groups.find((group) => group.sphereIds.includes(sphereId));
}

// Get the start sphere id with appropriate fallbacks for non-existent spheres
// defaultStartSphereId -> startGroupId.startSphereId -> first group startSphereId -> first sphere in list
function getStartSphereId(tourData, defaultStartSphereId) {
    let startSphereId;

    if (defaultStartSphereId && getSphereById(tourData, defaultStartSphereId)) {
        startSphereId = defaultStartSphereId;
    } else {
        let startGroupId = tourData.startGroupId || tourData.groups[0].groupId;
        startSphereId = findStartSphereIdForAGroup(tourData, startGroupId);
    }

    if (getSphereById(tourData, startSphereId)) {
        return startSphereId;
    }
    return tourData.spheres[0].sphereId;
}

function getSphereImageName(sphere, useMediaGateway = false) {
    return useMediaGateway && sphere.mediaGatewayURL ? sphere.mediaGatewayURL : sphere.image;
}

function getStartImageName(tourData, defaultStartSphereId, useMediaGateway = false) {
    const startSphere = getSphereById(tourData, getStartSphereId(tourData, defaultStartSphereId));
    return getSphereImageName(startSphere, useMediaGateway);
}

module.exports = {
    getSphereById,
    findGroupById,
    findStartSphereIdForAGroup,
    findGroupBySphereId,
    getStartImageName,
    getStartSphereId,
    getSphereImageName
};
